import { Injectable } from '@angular/core';

import { FirebaseApp, initializeApp } from 'firebase/app';
import { environment } from '@environment';
import { AppCheck, getToken, initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { PlatformService } from '../util/platform.service';
import { GtmService } from '../analytics/gtm.service';

import * as Sentry from '@sentry/browser';

@Injectable({
    providedIn: 'root'
})
export class FirebaseService {

	app: FirebaseApp;
    appCheck: AppCheck;

    constructor(
        private platformService: PlatformService,
        private gtmService: GtmService
    ) {
        if (this.platformService.isBrowser()) {
			this.initAppInstance();
        }
    }

    initFirebase() {
		if (this.platformService.isServer()) {
			return;
		}

		if (!this.app) {
			this.initAppInstance();
		}

		if (this.app && !this.appCheck) {
			this.initAppCheck();
		}
    }

    async getAppCheckToken(action: string) {

		const startTime = Date.now();

        try {

			this.initFirebase();

			if (this.app && this.appCheck) {
				return await getToken(this.appCheck, true);
			}

			return { token: '' };

        } catch (err) {
            this.gtmService.endTimer(startTime, 'js_errors', {
                event_action: `Firebase App Check Error: ${action}`,
                event_label: JSON.stringify(err)
            });
            Sentry.captureException(`Unable to fetch app check token: ${err}`);
            return { token: '' };
        }
    }

	private initAppCheck(): void {
		if (this.app && !this.appCheck) {
			try {
				this.appCheck = initializeAppCheck(this.app, {
					provider: new ReCaptchaV3Provider(environment.recaptchaSiteKey),
					isTokenAutoRefreshEnabled: true
				});
			} catch (error) {
				Sentry.captureException(`Failed to initialize App Check: ${error}`);
			}
		}
	}

	private initAppInstance(): void {
		if (!this.app) {
			try {
				this.app = initializeApp(environment.firebaseConfig);
			} catch (error) {
				Sentry.captureException(`Failed to initialize Firebase App: ${error}`);
			}
		}
	}
}
